import { f7 } from 'framework7-react';
import { useCallback, useMemo } from 'react';
import {
  ProgressItemType,
  RepairProgressImageInfoType,
} from '../../../types/bodyAndPaint';
import { useRepairImageCheckData } from './hook/useRepairImageCheckData';
import { useStorageItem } from './hook/useStorageItem';
import './repairImageCheck/repairImageCheck.css';
import { RepairPartImageCard } from './repairImageCheck/repairPartImageCard';
import { PageTemplateComponent } from './util/common/pageTemplate/pageTemplate';
import { paths } from '@/config/paths';

export const RepairImageCheckPage = () => {
  const { stored } = useStorageItem<{
    inspectionID: number;
  }>({ key: 'repairCheckRepairImage' });
  const { setStorageItem: setProgressItem } = useStorageItem<{
    label: string;
    checkInImage: string[];
    item: ProgressItemType[];
  }>({ key: 'repairProcessImage' });
  const inspectionID = useMemo(() => stored?.inspectionID ?? 0, [stored]);
  const { repairImageCheckData } = useRepairImageCheckData({ inspectionID });

  const handleClickBack = () => {
    f7.views.main.router.navigate(paths.bpsRepairInfoDetail);
  };

  const handleClickCheckProgress = useCallback(
    (index: number) => {
      setProgressItem({
        label: repairImageCheckData[index].repair_item_list.join(),
        checkInImage: repairImageCheckData[index].image_url_list,
        item:
          repairImageCheckData[index]?.progress_item ??
          ([] as ProgressItemType[]),
      });
      f7.views.main.router.navigate(paths.bpsRepairProcessImage);
    },
    [repairImageCheckData, setProgressItem],
  );
  return (
    <PageTemplateComponent
      pageName={'repairImageCheck'}
      title={'修理箇所の確認'}
      onBack={handleClickBack}
    >
      <RepairImageCheck
        data={repairImageCheckData}
        onClickProgress={handleClickCheckProgress}
      />
    </PageTemplateComponent>
  );
};

interface RepairImageCheckProps {
  data: RepairProgressImageInfoType[];
  onClickProgress: (index: number) => void;
}
export const RepairImageCheck = ({
  data,
  onClickProgress,
}: RepairImageCheckProps) => {
  return (
    <div className={'repair-image-check-field'}>
      {(data ?? []).map((imageInfo, idx) => (
        <RepairPartImageCard
          info={imageInfo}
          key={idx}
          onClick={() => onClickProgress(idx)}
        />
      ))}
    </div>
  );
};
